
import Vue from "vue";
import i18n from "@/i18n";

export default Vue.extend({
  name: "SectionFactorUseFrom2025",
  props: {
    isEditable: {
      type: Boolean,
      required: true,
    },
    tempData: {
      type: Object,
      required: true,
    },
    countrySelected: {
      type: Object,
      required: true,
    },
    currentSurveyYear: {
      type: Number,
      required: true,
    },
    rules: {
      type: Object,
    },
  },
  data: () => ({
    hasFVIIITotalError: false,
    hasFIXTotalError: false,
  }),
  computed: {
    isPrinting() {
      return this.$store.getters["datamanager/isPrinting"];
    },
  },
  methods: {
    validationTotalFVIII() {
      if (
        this.tempData.factorVIII_PlasmaDerivedConcentrates_IsNotKnown == true &&
        this.tempData.factorVIII_RecombinantConcentrates_IsNotKnown == true &&
        this.tempData
          .factorVIII_RecombinantExtendedHalfLifeConcentrates_IsNotKnown == true
      ) {
        this.hasFVIIITotalError = false;
        return [true];
      } else if (
        (this.tempData.factorVIII_FactorConcentrates_TotalIU || 0) -
          (this.tempData.factorVIII_PlasmaDerivedConcentrates_TotalIU || 0) -
          (this.tempData.factorVIII_RecombinantConcentrates_TotalIU || 0) -
          (this.tempData
            .factorVIII_RecombinantExtendedHalfLifeConcentrates_TotalIU || 0) !=
        0
      ) {
        this.hasFVIIITotalError = true;
        return [false]; //Doit etre egale a la somme total
      } else {
        this.hasFVIIITotalError = false;
        return [true];
      }
    },
    validationTotalFIX() {
      if (
        this.tempData.factorIX_PlasmaDerivedConcentrates_IsNotKnown == true &&
        this.tempData.factorIX_RecombinantConcentrates_IsNotKnown == true &&
        this.tempData
          .factorIX_RecombinantExtendedHalfLifeConcentrates_IsNotKnown == true
      ) {
        this.hasFIXTotalError = false;
        return [true];
      } else if (
        (this.tempData.factorIX_FactorConcentrates_TotalIU || 0) -
          (this.tempData.factorIX_PlasmaDerivedConcentrates_TotalIU || 0) -
          (this.tempData.factorIX_RecombinantConcentrates_TotalIU || 0) -
          (this.tempData
            .factorIX_RecombinantExtendedHalfLifeConcentrates_TotalIU || 0) !=
        0
      ) {
        this.hasFIXTotalError = true;
        return [false]; //Doit etre egale a la somme total
      } else {
        this.hasFIXTotalError = false;
        return [true];
      }
    },
    removeValueCauseNotKnown(selectedNotKnown: number) {
      //si coche isNotKnown - met text a null
      switch (selectedNotKnown) {
        case 1:
          this.tempData.factorVIII_IsUnableToReport = false;
          this.tempData.factorVIII_FactorConcentrates_TotalIU = null;
          this.hasFVIIITotalError = false;
          break;
        case 2:
          this.tempData.factorVIII_IsUnableToReport = false;
          this.tempData.factorVIII_PlasmaDerivedConcentrates_TotalIU = null;
          break;
        case 3:
          this.tempData.factorVIII_IsUnableToReport = false;
          this.tempData.factorVIII_RecombinantConcentrates_TotalIU = null;
          break;
        case 4:
          this.tempData.factorVIII_IsUnableToReport = false;
          this.tempData.factorVIII_RecombinantExtendedHalfLifeConcentrates_TotalIU = null;
          break;
        case 5:
          this.tempData.factorIX_IsUnableToReport = false;
          this.tempData.factorIX_FactorConcentrates_TotalIU = null;
          this.hasFIXTotalError = false;
          break;
        case 6:
          this.tempData.factorIX_IsUnableToReport = false;
          this.tempData.factorIX_PlasmaDerivedConcentrates_TotalIU = null;
          break;
        case 7:
          this.tempData.factorIX_IsUnableToReport = false;
          this.tempData.factorIX_RecombinantConcentrates_TotalIU = null;
          break;
        case 8:
          this.tempData.factorIX_IsUnableToReport = false;
          this.tempData.factorIX_RecombinantExtendedHalfLifeConcentrates_TotalIU = null;
          break;
        case 9:
          this.tempData.factorVIII_DonatedFactorConcentrates_TotalIU = null;
          break;
        case 10:
          this.tempData.factorIX_DonatedFactorConcentrates_TotalIU = null;
          break;
        case 11:
          this.tempData.purchasedHemlibra_TotalMg = null;
          break;
        case 12:
          this.tempData.purchasedFactorVIIA_TotalMg = null;
          break;
        case 13:
          this.tempData.purchasedFEIBA_TotalIU = null;
          break;
        case 14:
          this.tempData.geneTherapy_SurveyYearTotal = null;
          break;
        case 15:
          this.tempData.geneTherapy_Total = null;
          break;
        case 16:
          this.tempData.purchasedAltuviiio_Total = null;
          break;
        case 17:
          this.tempData.purchasedRebalancingAgents_Total = null;
          break;
      }
    },
    removeFactorVIIICauseIsUnableToReport() {
      //si coche unableToReport - met toute la section a null
      if (this.tempData.factorVIII_IsUnableToReport) {
        this.tempData.factorVIII_FactorConcentrates_TotalIU = null;
        this.tempData.factorVIII_FactorConcentrates_IsNotKnown = false;
        this.tempData.factorVIII_PlasmaDerivedConcentrates_TotalIU = null;
        this.tempData.factorVIII_PlasmaDerivedConcentrates_IsNotKnown = false;
        this.tempData.factorVIII_RecombinantConcentrates_TotalIU = null;
        this.tempData.factorVIII_RecombinantConcentrates_IsNotKnown = false;
        this.tempData.factorVIII_RecombinantExtendedHalfLifeConcentrates_TotalIU = null;
        this.tempData.factorVIII_RecombinantExtendedHalfLifeConcentrates_IsNotKnown = false;
      }
    },
    removeFactorIXCauseIsUnableToReport() {
      //si coche unableToReport - met toute la section a null
      if (this.tempData.factorIX_IsUnableToReport) {
        this.tempData.factorIX_FactorConcentrates_TotalIU = null;
        this.tempData.factorIX_FactorConcentrates_IsNotKnown = false;
        this.tempData.factorIX_PlasmaDerivedConcentrates_TotalIU = null;
        this.tempData.factorIX_PlasmaDerivedConcentrates_IsNotKnown = false;
        this.tempData.factorIX_RecombinantConcentrates_TotalIU = null;
        this.tempData.factorIX_RecombinantConcentrates_IsNotKnown = false;
        this.tempData.factorIX_RecombinantExtendedHalfLifeConcentrates_TotalIU = null;
        this.tempData.factorIX_RecombinantExtendedHalfLifeConcentrates_IsNotKnown = false;
      }
    },
  },
  watch: {
  },
});
